import React, { Component } from 'react';
import Axios from 'axios';
import { API_URL } from '../API_url/API_URL';
import { Button } from 'reactstrap';
import Loader from 'react-loader-spinner';
import { Redirect } from 'react-router-dom';
import {connect} from 'react-redux';

class MovieDetail extends Component {
    state = { 
        data: [],
        redirectPurchase: false,
        redirectLogin: false
    }

    componentDidMount(){
        let id = this.props.location.search.split('=')[1];
        console.log(id)
        Axios.get(API_URL+`/movies/${id}`)
        .then((res) => {
            this.setState({data: res.data})
            console.log(this.state.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    renderGenreButton = () => {
        let { genre } = this.state.data;
        if(genre){
            return genre.map((val, index) => {
                return <Button className='btn-custom' color='info' key={index}>{val}</Button>
            })
        }
    }

    renderCast = () => {
        let { casts } = this.state.data;
        if(casts){ 
            return casts.map((val) => {
                return `${val}, `
            })
        }
    }

    onBtnReservation = () => {
        let { username } = this.props;
        if(username){
            this.setState({ redirectPurchase: true})
        }else{
            this.setState({ redirectLogin: true})
        }
    }

    render() { 
        let { data, redirectPurchase, redirectLogin } = this.state;
        if(redirectLogin){
            return(
                <Redirect to='/login' />
            )
        }else if(redirectPurchase){
            return(
                <Redirect to={{pathname : '/reservation', state: this.state.data }}/>
            )
        }
        
        if(data === []){
            return(
                <div className='d-flex justify-content-center'>
                    <Loader 
                        type='Circles'
                        color='#DC3545'
                        height={200}
                        width={200}
                    />
                </div>
                )
        }else{

            return ( 
                <div className='container'>
                    <br/>
                <div className='row'>
                    <div className='col-4'>
                        <img src={data.image} alt='display poster'/>
                    </div>
                    <div className='col-8'>
                        <div className='vertical-spacing'>
                            <h2>
                                {data.name}
                            </h2>
                        </div>
                        <div className='vertical-spacing'>
                            <b>Director: </b> {data.director}
                        </div>
                        <div className='vertical-spacing'>
                            <b>Cast: </b> {this.renderCast()}
                        </div>
                        <div className='vertical-spacing'>
                            <b>Duration: </b> {data.duration} Minutes
                        </div>
                        <br/>
                        <div className='vertical-spacing'>
                            {this.renderGenreButton()}
                        </div>
                        <div className='vertical-spacing'>
                            {data.synopsis}
                        </div>
                        <div className='vertical-spacing' style={{ marginTop: '100px', float: 'right'}}>
                            <Button color='danger' className='btn-custom' onClick={this.onBtnReservation}>Choose My Seats</Button>
                        </div>
                    </div>
                </div>
            </div>
         );
        }
    }
}

const mapStateToProps = ({auth}) => {
    return{
        username : auth.username
    }
}
 
export default connect(mapStateToProps)(MovieDetail);